import SignContainer from "../../../../components/basic/SignContainer";
import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailSummaryPrintButton,
} from "../../../../components/detailLayout";
import React from "react";
import {removeIncidentReport} from "../../../../api/maintenance/IncidentService";
import {ContentCategory} from "../../../../constant/CodeSpecNum";
import {IncidentRequestInfoPanel, IncidentReportBodyPanel} from "./incidentReportPanels";

function IncidentReportView({incident, assets, handler, statusNumericValue, incidentReport, setIncidentReport}) {
    const remove = async () => {
        const response = await removeIncidentReport({id: incidentReport.id});
        if (response.status === 200) {
            setIncidentReport({});
            alert("장애보고서가 정상적으로 삭제되었습니다.");
        }
    };

    const movePage = {
        url: `/maintenance/incident/report/update/${incident.id}`,
        content: "수정페이지",
    };

    const summaryMeta = [
        incident.incidentCode?.name && `유형 ${incident.incidentCode.name}`,
        incident.requester?.name && `요청 ${incident.requester.name}`,
    ].filter(Boolean).join(" · ");

    if (Object.keys(incidentReport).length === 0) {
        return null;
    }

    return (
        <ContentDetailInfoShell
            title={incident?.title || "장애보고서"}
            meta={summaryMeta || incident?.serialNumber}
            contentId={incident.id}
            contentCategory={ContentCategory.INCIDENT}
            scrollMode="columns"
            listUrl="/maintenance/incident"
            actions={<DetailSummaryPrintButton />}
            rollup={{
                remove: incident.auth?.update && remove,
                movePage: incident.auth?.update && movePage,
            }}
        >
            <ContentDetailThreeColLayout
                primary={<IncidentRequestInfoPanel incident={incident} assets={assets} handler={handler} />}
                secondary={
                    <IncidentReportBodyPanel
                        incident={incident}
                        incidentReport={incidentReport}
                        readOnly
                    />
                }
                aside={
                    <>
                        <SignContainer
                            contentId={incident.id}
                            contentCategory={"INCIDENT"}
                            statusNumericValue={statusNumericValue}
                        />
                        <DetailFilePanel
                            isEditing={false}
                            showFileLabel={false}
                            tableInfo={{tableName: "incident_report", joinKey: incidentReport.id}}
                        />
                    </>
                }
            />
        </ContentDetailInfoShell>
    );
}

export {IncidentReportView};
